<template>
    <div class="optional-selection max-lg:tw-px-6">
        <h3
            class="optional-selection__title tw-mt-8 lg:tw-mt-14 tw-mb-6 lg:tw-mb-10 headline-md tw-font-bold tw-text-center"
        >
            {{ $t('configuration-wizard.select-the-optionals') }}
        </h3>
        <div class="optional-selection__body">
            <version-optionals
                :version-id="versionId"
                :categories="categories"
                :base-price="basePrice"
                has-dealer-selection-layout
                @changed-optionals="onOptionalSelect"
            />
        </div>
    </div>
</template>

<script>
/**
 * An optional selection component
 */
export default {
    name: 'OptionalSelection',
    components: {
        VersionOptionals: () => ({
            component: import(
                /* webpackChunkName: "VersionOptionals-vue" */ '@v4/multi-section/components/organisms/VersionOptionals'
            ),
        }),
    },
    props: {
        /**
         * Selected version
         */
        selectedVersion: {
            type: Object,
            default: () => ({}),
        },
        /**
         * The optional categories
         */
        categories: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        versionId() {
            const version = this.selectedVersion || {};
            return version.versionId || '';
        },
        basePrice() {
            const version = this.selectedVersion || {};
            return (version.pricing && version.pricing.basePrice) || 0;
        },
    },
    methods: {
        onOptionalSelect(optionals) {
            /**
             * Fired when clicked on the trim item
             *
             * @event click
             * @type {object}
             * @property {object} optionals - optional list
             */
            this.$emit('optional-select', optionals);
        },
    },
};
</script>
